module.exports = __webpack_public_path__ + "img/05.187a60d8.jpg";